module.exports = "<div class=\"wrapper\">\r\n    <app-sidebar-layout></app-sidebar-layout>\r\n    <div id=\"content\">\r\n        <app-topbar-layout></app-topbar-layout>\r\n        <div id=\"menuContent\">\r\n            <router-outlet></router-outlet>\r\n        </div>\r\n    </div>\r\n</div>\r\n<div id=\"unfocus\">\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/layouts/gui-layout/gui-layout.component.html
// module id = ./src/app/layouts/gui-layout/gui-layout.component.html
// module chunks = main